import { render, staticRenderFns } from "./CapturaFoto.vue?vue&type=template&id=0b07f862&scoped=true"
import script from "./CapturaFoto.vue?vue&type=script&lang=js"
export * from "./CapturaFoto.vue?vue&type=script&lang=js"
import style0 from "./CapturaFoto.vue?vue&type=style&index=0&id=0b07f862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b07f862",
  null
  
)

export default component.exports